import React from "react";
import { Helmet } from "react-helmet-async";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const ForgotPassword: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Reset Password | SaunaDip</title>
        <meta name="description" content="Reset your SaunaDip password" />
      </Helmet>
      
      <div className="bg-sauna-beige px-4 mt-0 flex justify-center">
        <div className="w-full max-w-md">
          <ForgotPasswordForm />
          
          <div className="mt-4 text-center">
            <Button asChild variant="ghost" className="text-sm">
              <Link to="/">
                <ArrowLeft size={16} className="mr-1" />
                Back to Home
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
